const NORMALIZED_MIN_SOURCE_GRANULARITY_MINUTES = 15

export const getNormalizedSourceGranularityMinutes = (minutes?: number | null): number | null => {
  if (typeof minutes !== 'number' || !Number.isFinite(minutes) || minutes <= 0) return null
  return minutes < NORMALIZED_MIN_SOURCE_GRANULARITY_MINUTES ? NORMALIZED_MIN_SOURCE_GRANULARITY_MINUTES : minutes
}
